export default __webpack_public_path__ + "static/media/walks.80eb134c.svg";